import { render, staticRenderFns } from "./PorletGraficas.vue?vue&type=template&id=4180cb64"
import script from "./PorletGraficas.vue?vue&type=script&lang=js"
export * from "./PorletGraficas.vue?vue&type=script&lang=js"
import style0 from "./PorletGraficas.vue?vue&type=style&index=0&id=4180cb64&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports